/* globals $, leaderboardData, queryString */
import Table from 'bam-node-savant-table/table'
import { guff } from 'bam-node-baseball-savant/utils/guff'
import formatPitchLabel from 'bam-node-baseball-savant/utils/format-pitch-label.ts'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'arsenalStats'

$(() => {
    $('#btnUpdate').click(() => {
        window.location.href = populateUrl()
    })

    $('#btnCSV').click(() => {
        window.location.href = `${populateUrl()}&csv=true`
    })
})

$(document).ready(() => {
    $('form').submit(false)
    $('#ddlTeamId').change(() => {
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    })

    $('#ddlSeason').change(() => {
        $('#lblSeason').html($('#ddlSeason').val())
    })
    $('#ddlMin').change(() => {
        $('#lblMin').html(`Min. PA: ${$('#ddlMin option:selected').text()}`)
    })
    $('#ddlMinPitches').change(() => {
        $('#lblMinPitches').html(
            `Min. Pitches: ${$('#ddlMinPitches option:selected').text()}`
        )
    })
    $('#ddlType').change(() => {
        $('#lblType').html($('#ddlType option:selected').text())
    })
    $('#ddlPitchType').change(() => {
        $('#lblPitchType').html($('#ddlPitchType option:selected').text())
    })

    if (queryString.type) {
        if (queryString.type.indexOf('team') > -1) {
            $('#team-ddl').hide()
        }
        $('#ddlType').val(queryString.type).attr('selected', true)
        $('#lblType').html($('#ddlType option:selected').text())
    }
    if (queryString.pitchType === 'CUKC') {
        $('#ddlPitchType').val('CU').attr('selected', true)
    } else if (queryString.pitchType === 'SIFT') {
        $('#ddlPitchType').val('SI').attr('selected', true)
    }

    $('#lblPitchType').html($('#ddlPitchType option:selected').text())

    if (queryString.year) {
        $('#ddlSeason').val(queryString.year).attr('selected', true)
        $('#lblSeason').html($('#ddlSeason').val())
    }

    if (queryString.team) {
        $('#ddlTeamId').val(queryString.team).attr('selected', true)
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    }
    if (queryString.sortDir) {
        $('#sortDir').val(queryString.sortDir)
    }

    if (queryString.sort) {
        $('#sort').val(queryString.sort)
    }

    if (leaderboardData && leaderboardData.length > 0) {
        const secondaryHeaders = [
            {
                name: '',
                colspan: 4,
                headerClass: 'th-name-header',
            },
            {
                name: '',
                colspan: 2,
                headerClass: 'th-title-header',
            },
            {
                name: 'Usage',
                colspan: 2,
                headerClass: 'th-title-header',
            },
            {
                name: 'Standard',
                colspan: 7,
                headerClass: 'th-title-header',
            },
            {
                name: 'Statcast',
                colspan: 5,
                headerClass: 'th-title-header',
            },
        ]

        const headers = [
            {
                name: 'Player',
                field: 'href',
                customSortField: 'player_name',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'player_id',
            },
            {
                name: 'Team',
                field: 'team_name_alt',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />',
                photoId: 'team_id',
                photoOnly: true,
            },
            {
                name: 'Pitch',
                field: 'pitch_name',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                displayFn: (val, { pitch_type }) =>
                    formatPitchLabel(pitch_type),
            },
            {
                name: 'RV/100',
                field: 'run_value_per_100',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                toolTip: 'Run Value / 100 Pitches',
                displayFn: (val) => guff(val, 'pitcher_run_value_per_100'),
            },
            {
                name: 'Run Value',
                field: 'run_value',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                highlightDynamic: true,
            },
            {
                name: 'Pitches',
                field: 'pitches',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                displayFn: (val) => guff(val, 'pitch_count'),
            },
            {
                name: '%',
                field: 'pitch_usage',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) =>
                    guff(val / 100, 'pitch_percent', { removePercent: true }),
            },
            {
                name: 'PA',
                field: 'pa',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
            },
            {
                name: 'BA',
                field: 'ba',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => guff(val, 'ba'),
            },
            {
                name: 'SLG',
                field: 'slg',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => guff(val, 'slg'),
            },
            {
                name: 'wOBA',
                field: 'woba',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => guff(val, 'woba'),
            },
            {
                name: 'Whiff %',
                field: 'whiff_percent',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                toolTip: 'Swing & Miss / Total Swings',
                displayFn: (val) => guff(val, 'whiff_percent'),
            },
            {
                name: 'K%',
                field: 'k_percent',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => guff(val, 'k_percent'),
            },
            {
                name: 'Put Away %',
                field: 'put_away',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => guff(val, 'putaway_percent'),
            },
            {
                name: 'xBA',
                field: 'est_ba',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                displayFn: (val) => guff(val, 'xba'),
            },
            {
                name: 'xSLG',
                field: 'est_slg',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => guff(val, 'xslg'),
            },
            {
                name: 'xwOBA',
                field: 'est_woba',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => guff(val, 'xwoba'),
            },
            {
                name: 'Hard Hit %',
                field: 'hard_hit_percent',
                type: 'number',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
                displayFn: (val) => guff(val, 'hard_hit_percent'),
            },
        ]

        const width = $(`#${tableDivId}`).outerWidth()
        let repeatHeaders = false
        if (width <= 768) {
            repeatHeaders = 15
        }

        // eslint-disable-next-line no-new
        new Table({
            id: tableDivId,
            repeatHeader: repeatHeaders,
            secondaryHeaders,
            headers,
            defaultSort:
                headers[Number($('#sort').val())].customSortField ||
                headers[Number($('#sort').val())].field,
            defaultSortDirection: $('#sortDir').val(),
            sortClass: 'column-sort',
            // PASS IN UNIQUE ROW ID... Use this for ajax calls
            subDataId: 'rowId',
            showRank: true,
            data: leaderboardData,
        })
    }

    window.addEventListener('scroll', () => {
        if (!ticking && leaderboardData.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            // console.log(width);
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $(`#${divId} table .default-table-row`)
                .first()
                .children('td')
                .each(function handleEach() {
                    const width2 = $(this).outerWidth()
                    $(
                        `#${divId} table .tr-component-row th:nth-child(${
                            tableCell + 1
                        })`
                    ).css('width', width2)
                    tableCell += 1
                })

            $(`#${divId} table thead`).first().addClass('fixed-header')
            tableCell = 0

            // Set TD Width before applying fixed-header
            $(`#${divId} table .tr-component-row`)
                .children('th')
                .each(function handleEach() {
                    const width2 = $(this).outerWidth()
                    $(
                        `#${divId} table .default-table-row td:nth-child(${
                            tableCell + 1
                        })`
                    ).css('width', width2)
                    tableCell += 1
                })
        }
    }

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })

    if ($('#ddlType').val().indexOf('team') === -1) {
        $(`#${tableDivId}`).on(
            'click',
            '.default-table-row[id^=arsenalStats-tr]',
            function handleClick() {
                const playerId = this.id.split('_')[1]
                const pitchType = this.id.split('_')[2]

                if (
                    $(`#${tableDivId}-trSub_${playerId}_${pitchType}`).is(
                        ':visible'
                    )
                ) {
                    $(`#${tableDivId}-trSub_${playerId}_${pitchType}`).hide()
                } else {
                    $.ajax({
                        method: 'GET',
                        url: '/leaderboard/pitch-arsenal-stats',
                        data: {
                            details: 'true',
                            player_id: playerId,
                            year: $('#ddlSeason').val(),
                            min_ab: $('#ddlMin').val(),
                            type: $('#ddlType').val(),
                            pitchType,
                        },
                    }).done((json) => {
                        $(`#${tableDivId}-tdSub_${playerId}_${pitchType}`).html(
                            `<div id="data_${playerId}_${pitchType}"></div>`
                        )
                        $(
                            `#${tableDivId}-trSub_${playerId}_${pitchType}`
                        ).show()

                        for (let x = 0; x < json.length; x++) {
                            if (
                                json[x].play_id &&
                                Number($('#ddlSeason').val()) >= 2018
                            ) {
                                // eslint-disable-next-line no-param-reassign
                                json[
                                    x
                                ].video = `<a href="/sporty-videos?playId=${json[x].play_id}" target="_blank"><img src="/site-core/images/video.png" title="Show Video" style="width: 25px; height: 13px; cursor: pointer;" /></a>`
                            } else {
                                // eslint-disable-next-line no-param-reassign
                                json[x].video = ''
                            }
                        }

                        // eslint-disable-next-line no-new
                        new Table({
                            id: `data_${playerId}_${pitchType}`,
                            headers: [
                                {
                                    name: 'Date',
                                    field: 'game_date',
                                    headerClass: 'th-component-header',
                                    fieldClass: 'tr-data',
                                },
                                {
                                    name: 'Pitcher',
                                    field: 'pitcher_name',
                                    headerClass:
                                        'th-component-header align-left',
                                    fieldClass: 'tr-data align-left',
                                    photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                                    photoId: 'pitcher_id',
                                },
                                {
                                    name: 'Batter',
                                    field: 'batter_name',
                                    headerClass:
                                        'th-component-header align-left',
                                    fieldClass: 'tr-data align-left',
                                    photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                                    photoId: 'batter_id',
                                },
                                {
                                    name: 'Pitch Type',
                                    field: 'pitch_name',
                                    headerClass:
                                        'th-component-header align-center',
                                    fieldClass: 'tr-data align-center',
                                    displayFn: () =>
                                        formatPitchLabel(pitchType),
                                },
                                {
                                    name: 'Pitch Speed',
                                    field: 'pitch_speed',
                                    type: 'number',
                                    headerClass:
                                        'th-component-header align-center',
                                    fieldClass: 'tr-data align-center',
                                },
                                {
                                    name: 'Result',
                                    field: 'event_type',
                                    headerClass:
                                        'th-component-header align-left',
                                    fieldClass: 'tr-data align-left',
                                    displayFn: (val) => formatResultString(val),
                                },
                                {
                                    name: 'Video',
                                    field: 'video',
                                    headerClass: 'th-component-header',
                                    fieldClass: 'tr-data',
                                },
                            ],
                            data: json,
                        })
                    })
                }
            }
        )
    }

    $(document).on('click', 'th.th-component-header', function handleClick() {
        const id = this.id.split('-')[1]

        if (Number($('#sort').val()) === Number(id)) {
            if ($('#sortDir').val() === 'desc') {
                $('#sortDir').val('asc')
            } else {
                $('#sortDir').val('desc')
            }
        } else {
            $('#sortDir').val('desc')
        }
        $('#sort').val(id)
        isFixedHeaderShowing = false
        checkHeaderPosition(tableDivId)
        const newUrl = populateUrl()
        window.history.replaceState('', '', newUrl)
    })

    function formatResultString(str) {
        return str
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
    }
})

function populateUrl() {
    const url = `/leaderboard/pitch-arsenal-stats?type=${$(
        '#ddlType'
    ).val()}&pitchType=${$('#ddlPitchType').val()}&year=${$(
        '#ddlSeason'
    ).val()}&team=${$('#ddlTeamId').val()}&min=${$(
        '#ddlMin'
    ).val()}&minPitches=${$('#ddlMinPitches').val()}&sort=${$(
        '#sort'
    ).val()}&sortDir=${$('#sortDir').val()}`
    return url
}
